import React from 'react';
import ReactDOM from 'react-dom';


import 'bootstrap/dist/css/bootstrap.min.css';
// Después de Bootstrap y antes que el resto: las fichas de diseño las consumen
// todas las hojas de la aplicación.
import './assets/style/tokens.css';
import App from './App';

const container = document.getElementById("root");
ReactDOM.render(<App/>, container)